import { RowValuesWithEcomodClass } from "./rowValues.models";

export enum ReportStatus {
  Draft = 1,
  Sent = 2,
  WaitingForApproval = 3,
}

export enum ReportType {
  EAN = 1,
  LIGHT = 2,
  DETAILED = 3,
}

export enum InternalReportStatusEnum {
  ToBeReviewed = "ToBeReviewed",
  ReturnedForCorrection = "ReturnedForCorrection",
  ApprovedAutomatically = "ApprovedAutomatically",
  ApprovedManually = "ApprovedManually",
}

export type Report = {
  id: number;
  companyId: number;
  organizationId?: number;
  year: number;
  quarter: number;
  month: number;
  reportType: ReportType;
  created?: string;
  modified?: string;
  reportStatus?: ReportStatus;
  rows: ReportRow[];
  comment?: string;
  internalReportStatus?: InternalReportStatusEnum;
  approvedAt?: string;
  approvedBy?: number;
};

export type ReportRow = {
  id: number;
  ean: string;
  name: string;
  akeneoId: string;
  amount: number;
  active: boolean;
  values: RowValuesWithEcomodClass[];
  comment: string;
  created: string;
  modified: string;
  internalReference?: string;
};

export type CreateReportPayload = {
  companyId: number;
  organizationId?: number;
  year: number;
  quarter?: number;
  month?: number;
  reportStatus?: ReportStatus;
  rows?: ReportRowPayload[];
  comment?: string;
  reportType: ReportType;
};

export type UpdateReportPayload = {
  id: number;
  companyId: number;
  organizationId?: number;
  year: number;
  quarter?: number;
  month?: number;
  reportStatus?: ReportStatus;
  rows?: ReportRowPayload[];
  comment?: string;
  reportType: ReportType;
  internalReportStatus?: InternalReportStatusEnum;
  approvedAt?: string;
  approvedBy?: number;
  invoiceId?: number;
  sentBy?: number;
  sentAt?: string;
};

export type CreateReportRowPayload = {
  id?: number;
  ean: string;
  name: string;
  akeneoId: string;
  amount: number;
  active: boolean;
  values: RowValuesWithEcomodClass[];
  internalReference?: string;
  comment?: string;
};

export type ReportRowPayload = {
  id: number;
  ean: string;
  name: string;
  akeneoId: string;
  amount: number;
  active: boolean;
  values: RowValuesWithEcomodClass[];
  internalReference?: string;
  comment?: string;
};
